import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ResumeImg from "../../assets/women-8080878_1280.png";
import logo from "../../assets/Thryiv_logo_tm_TB.png";
import { BRAND } from "./authTheme";

const DEFAULT_HERO = {
  title: "Empowering people through seamless HR management.",
  subtitle:
    "Efficiently manage your workforce and streamline operations effortlessly.",
};

const AuthLayout = ({
  title,
  subtitle,
  heroTitle = DEFAULT_HERO.title,
  heroSubtitle = DEFAULT_HERO.subtitle,
  children,
  maxWidth = 420,
  showFooter = true,
}) => (
  <Grid container sx={{ minHeight: "100vh", width: "100%" }}>
    <Grid
      item
      xs={false}
      md={6}
      sx={{
        position: "relative",
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        p: 6,
        backgroundImage: `url(${ResumeImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(26,43,74,0.88) 0%, rgba(26,43,74,0.65) 50%, rgba(255,106,0,0.35) 100%)",
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 480 }}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.75,
            mb: 3,
            borderRadius: "999px",
            bgcolor: "rgba(255,255,255,0.12)",
            backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: "#4ADE80",
            }}
          />
          <Typography variant="caption" sx={{ color: "#fff", fontWeight: 500 }}>
            Trusted HR platform
          </Typography>
        </Box>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            fontSize: { md: "2.25rem", lg: "2.5rem" },
            lineHeight: 1.25,
            letterSpacing: "-0.02em",
          }}
        >
          {heroTitle}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2.5,
            color: "rgba(255,255,255,0.85)",
            fontSize: "1.05rem",
            lineHeight: 1.7,
          }}
        >
          {heroSubtitle}
        </Typography>
      </Box>
    </Grid>

    <Grid
      item
      xs={12}
      md={6}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: BRAND.bg,
        px: { xs: 2.5, sm: 4 },
        py: { xs: 4, sm: 6 },
        minHeight: "100vh",
      }}
    >
      <Box sx={{ width: "100%", maxWidth }}>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: "center",
            mb: 3,
          }}
        >
          <img
            src={logo}
            alt="Thryiv"
            style={{ height: 52, objectFit: "contain" }}
          />
        </Box>

        <Box
          sx={{
            bgcolor: "#fff",
            borderRadius: "16px",
            border: `1px solid ${BRAND.border}`,
            boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
            p: { xs: 3, sm: 4 },
          }}
        >
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              mb: 1,
            }}
          >
            <img
              src={logo}
              alt="Thryiv"
              style={{ height: 56, objectFit: "contain" }}
            />
          </Box>

          <Typography
            variant="h5"
            align="center"
            sx={{
              fontWeight: 700,
              color: BRAND.navy,
              mt: { md: 1.5 },
              mb: subtitle ? 0.5 : 2,
            }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              align="center"
              sx={{ color: BRAND.muted, mb: 3 }}
            >
              {subtitle}
            </Typography>
          )}

          {children}
        </Box>

        {showFooter && (
          <Typography
            variant="caption"
            display="block"
            align="center"
            sx={{ mt: 3, color: BRAND.muted }}
          >
            Copyright © 2026 — Swatsan Tech Pvt. Ltd.
          </Typography>
        )}
      </Box>
    </Grid>
  </Grid>
);

export default AuthLayout;
